/**
 * D5 Budget & MMM: the thresholds and names the page, the API routes and the trainer's bundle share
 * (docs/superpowers/specs/2026-10-28-native-budget-mmm-design.md). Pure. api/_lib imports this module: relative
 * imports only, never '@/' — vite.config.ts loads that server code without the alias, and an '@/' import fails
 * `pnpm build`.
 *
 * @module services/budget/budgetContract
 */

export const OUTCOME_METRICS = ['revenue', 'leads', 'bookings', 'sales'] as const;
export type OutcomeMetric = (typeof OUTCOME_METRICS)[number];
/** Readiness checks 1–5 (plan R2): SQL computes the values, these are the thresholds. */
export const READINESS = { historyWeeks: 52, overlapWeeks: 26, minChannels: 2, continuityDays: 14, outcomeCoverage: 0.9 } as const;
/** Spec §5.2's model-quality tiles. */
export const QUALITY = { minR2: 0.8, maxMape: 0.1, maxRhat: 1.2, maxDivergences: 0 } as const;
/** The most a channel's budget moves from its current figure, either way. */
export const MAX_SHIFT = 0.3;
/** Plan R16: a version is stale once its data's last day is more than this many days old. */
export const STALE_DAYS = 45;
export const DATASET_SCHEMA = 'ydm.mmm.dataset/1';
export const BUNDLE_SCHEMA = 'ydm.mmm.bundle/1';
/** Plan R24: the fixture whose passing validation lets real uploads in. */
export const VALIDATION_FIXTURE = 'mmm-ready';
export const AD_PLATFORMS = ['facebook', 'google', 'tiktok', 'line'] as const;
